import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import { ListingStateEnum } from "./Enums";
export var VALID_LISTING_STATES = [ListingStateEnum.PREDICTED, ListingStateEnum.ON_MARKET, ListingStateEnum.LEASED, ListingStateEnum.NOT_AVAILABLE];

/**
 * Consolidates listing states according to business rules:
 * - IN_PROPOSALS, IN_LEASES, and ON_MARKET all show as "On Market"
 * - NOT_AVAILABLE and DEAD both show as "Not Available"
 * - All other states return their original labels
 *
 * @param listingState - The original listing state value
 * @returns Valid listing state with value, label, and originalValue
 */
export var getValidListingStateLabels = function getValidListingStateLabels(listingState) {
  if (!listingState) {
    return null;
  }
  var originalStateObj = _valuesInstanceProperty(ListingStateEnum)[listingState];
  if (!originalStateObj) {
    return null;
  }

  // Consolidation rules
  switch (listingState) {
    case ListingStateEnum.IN_PROPOSALS.value:
    case ListingStateEnum.IN_LEASES.value:
    case ListingStateEnum.ON_MARKET.value:
      return {
        value: ListingStateEnum.ON_MARKET.value,
        label: ListingStateEnum.ON_MARKET.label,
        originalValue: listingState
      };
    case ListingStateEnum.NOT_AVAILABLE.value:
    case ListingStateEnum.DEAD.value:
      return {
        value: ListingStateEnum.NOT_AVAILABLE.value,
        label: ListingStateEnum.NOT_AVAILABLE.label,
        originalValue: listingState
      };
    default:
      // All other states (predicted, leased) return themselves
      return {
        value: originalStateObj.value,
        label: originalStateObj.label,
        originalValue: listingState
      };
  }
};

/**
 * Returns null for null/undefined/empty values, and 0 for zero values.
 * Otherwise returns the parsed number without altering its precision.
 *
 * Important for values that round-trip through edit mode (e.g. asking_rate,
 * where storage keeps 10 decimal places and a 2-decimal truncation silently
 * corrupts mixed-rate listings — see RKG-7554).
 */
export var preserveDecimalIfNotNull = function preserveDecimalIfNotNull(value) {
  if (value === 0) {
    return 0;
  }
  if (value === null || value === undefined || value === "") {
    return null;
  }
  var numValue = typeof value === "number" ? value : _parseFloat(value);
  if (isNaN(numValue)) {
    return null;
  }
  return numValue;
};